import React from 'react'
import PropTypes from 'prop-types'

import { Tooltip } from '@mui/material'
import moment from 'moment'
import { etatColor } from '../data'
import {
  StyledBoxDetail,
  StyledTypographyInfoDetail,
  StyledTypographyTitleDetail,
} from '../style'

const SessionBody = ({ row }) => {
  return (
    <>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Date de création:'}
        </StyledTypographyTitleDetail>
        <StyledTypographyInfoDetail component="div">
          {moment(new Date(row.createdAt)).format('YYYY-MM-DD')}
        </StyledTypographyInfoDetail>
      </StyledBoxDetail>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Formation:'}
        </StyledTypographyTitleDetail>
        <Tooltip
          title={<span className="tootltip-content">{row.formationName}</span>}
          arrow
        >
          <StyledTypographyInfoDetail>
            {row.formationName || '--'}
          </StyledTypographyInfoDetail>
        </Tooltip>
      </StyledBoxDetail>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Date Début:'}
        </StyledTypographyTitleDetail>
        <StyledTypographyInfoDetail component="div">
          {moment(new Date(row.startDate)).format('YYYY-MM-DD') || '--'}
        </StyledTypographyInfoDetail>
      </StyledBoxDetail>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Date Fin:'}
        </StyledTypographyTitleDetail>
        <StyledTypographyInfoDetail component="div">
          {moment(new Date(row.endDate)).format('YYYY-MM-DD') || '--'}
        </StyledTypographyInfoDetail>
      </StyledBoxDetail>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Lieu:'}
        </StyledTypographyTitleDetail>
        <StyledTypographyInfoDetail component="div">
          {row.place || '--'}
        </StyledTypographyInfoDetail>
      </StyledBoxDetail>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Formatteur:'}
        </StyledTypographyTitleDetail>
        <StyledTypographyInfoDetail component="div">
          {row.former || '--'}
        </StyledTypographyInfoDetail>
      </StyledBoxDetail>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Nombre de participants:'}
        </StyledTypographyTitleDetail>
        <StyledTypographyInfoDetail component="div">
          {row.participantsNbre || '--'}
        </StyledTypographyInfoDetail>
      </StyledBoxDetail>
      <StyledBoxDetail>
        <StyledTypographyTitleDetail variant="h2">
          {'Etat:'}
        </StyledTypographyTitleDetail>

        <StyledTypographyInfoDetail
          backgroundColor={
            row.state && etatColor.find((e) => e.etat === row.state).backgroundColor
          }
          color={row.state && etatColor.find((e) => e.etat === row.state).color}
          isEtat={row.state}
          component="div"
        >
          {etatColor.find((e) => e.etat === row.state)?.label}
        </StyledTypographyInfoDetail>
      </StyledBoxDetail>
    </>
  )
}
SessionBody.propTypes = {
  row: PropTypes.object,
}
export default SessionBody
